import React from 'react';
import Popup from '../../components/PopUp/PopUp';
import { Globals } from '../../global/Globals';
import CryptoUtils from '../../util/cryptoUtils';
import { setConsent } from '../../services/GenericAPI';

const TermsPopup = () => {
    const logConfiAgreement = async () => {
        const response = await setConsent();
    }
    return (
        <Popup title={Globals.SIGNUP.CONFIDENTIALITY_AGREEMENT}
            text={''}
            normalAction={logConfiAgreement}
            normalActionText={Globals.SIGNUP.POPUP.CONFIRM_BTN_TXT}
            popupType={"confidential-agreement"}
            onClose={() => { }}
            isCloseRequired={false}
        />
    );
}
export default TermsPopup;